<template>
  <div id="Opportunities_Thermatics">
    <usc-hero :title="this.hero.title" :loResSrc="this.hero.loResSrc" :hiResSrc="this.hero.hiResSrc" :color="this.page.color"></usc-hero>
    <usc-intro :copy="this.intro"><i>USC offers students of all majors the opportunity to earn special honors and designations while pursuing their passions.</i></usc-intro>
    <div class="body mb gutter-lg">
      <p>USC offers students of all majors the opportunity to earn special honors and designations while pursuing their passions.</p>
      <p><strong>Thematic Option Program</strong><br />Thematic Option is the university’s general education honors program, open to up to 200 freshmen from all USC majors. This interdisciplinary core curriculum offers small classes with some of the university’s best undergraduate teachers and a handpicked group of writing instructors. The program has been cited by numerous college guides as one of the nation’s best undergraduate honors programs, and student evaluations echo that assessment. Admission is very selective and based on academic achievement.</p>
      <p><i>USC’s undergraduate scholar programs salute excellence by recognizing students who surpass academic expectations. Interested students may apply for the respective scholars’ designations; recognized scholars receive a medallion to wear at graduation, have their designation noted on their final transcript and may be eligible for a $10,000 prize toward graduate study or other approved post-graduate endeavors. Seniors may earn more than one distinction but must meet the criteria for each application.</i></p>
      <p><strong>Renaissance and Discovery Scholars</strong><br />Undergraduates who pursue a major and minor (or two majors) in widely separated fields of study and maintain a minimum GPA may be honored as USC Renaissance Scholars, while students who excel in the classroom and also produce exceptional scholarship or artistic works are encouraged to pursue the Discovery Scholar honor, which is offered within every major concentration at the university.</p>
      <p><strong>Global Scholars</strong><br />The Global Scholars program recognizes undergraduates who have exceled in their studies both at home and abroad. Every year, up to 10 Global Scholars receive a $10,000 prize to be applied toward graduate study. Students must have an overall USC GPA of 3.5 or higher to be considered for this distinction and must have participated in an international program administered by USC or an outside institution.</p>
      <p>Applicants must have spent a minimum of 10 weeks abroad in one or more academic, work-experience or service-learning programs as part of their undergraduate experience. For international students, the overseas experience must be outside their home country, preferably in a different region of the world.</p>
      <p>Global Scholars are expected to complete a capstone paper, project or research paper in which they reflect on their international experience. This project, for which each USC school has different criteria, is intended to validate the depth and quality of the student’s time abroad.</p>
    </div>
  </div>
</template>

<script>
import hero from '@/components/Hero'
import intro from '@/components/Intro'
import Cta from '@/components/Cta'

export default {
  name: 'Thematic',
  components: {
    'usc-hero': hero,
    'usc-intro': intro,
    'usc-cta': Cta
  },
  data () {
    return {
      page: {
        color: '#ffcc00'
      },
      hero: {
        title: 'Distinctive Honors Opportunities',
        loResSrc: '../../../static/HeroImages/Advantages-Marshall20.jpg',
        hiResSrc: '../../../static/HeroImages/Advantages-Marshall20.jpg'
      }
    }
  },
  created () {
    this.$root.setPageHeader('Opportunities', 'Thematic')
  }
}
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/pages/advantages/Thematic.vue